import {Grid, Typography} from "@material-ui/core";
import SortingDropdown from "../../../../../../../../../../shared/components/sorting-dropdown/SortingDropdown";
import DeviceDetailsTable from "../../device-details-tables/DeviceDetailsTable";
import {useState} from "react";
import {headCellsConsegne, sortingCriteriaConsegna} from "../../device-details-tables/DeviceDetailsTableHelper";
import {useSelector} from "react-redux";
import PropTypes from "prop-types";

const ConsegneTable = (props) => {
    const data = useSelector(state => state.contrattoDigitaleReducer.deviceDetails.data.deviceConsegneList)
    const [sort, setSort] = useState(`${sortingCriteriaConsegna[0].value},desc`)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(5)

    const handleChangeData = (page, rowsPerPage) => {
        setPage(page)
        setRowsPerPage(rowsPerPage)
    }

    const handleSortingChange = (value) => {
        setSort(value)
    }

    return (
        <>
            <Grid item xs={12}>
                <Typography variant={"h6"}>Consegne</Typography>
            </Grid>
            <Grid item>
                <SortingDropdown sortingValue={sort}
                                 changeSortingCriteria={handleSortingChange}
                                 sortingCriteria={sortingCriteriaConsegna}/>
            </Grid>
            <Grid item xs={12}>
                <DeviceDetailsTable type="Consegne"
                                    tableData={data}
                                    headCells={headCellsConsegne}
                                    loading={props.loading}
                                    order={sort}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    count={data.length}
                                    changeData={handleChangeData}
                                    handleVediClick={props.handleVediClick}
                />
            </Grid>
        </>
    )
}

ConsegneTable.propTypes = {
    loading: PropTypes.bool.isRequired
}

export default ConsegneTable;